import { useTranslation } from 'react-i18next';

import { MAGIC_SEARCH_KEY_CLASS } from '../constants';

const KEY_HINTS = [
  { keys: ['↑', '↓'], label: 'menu:magicSearchKeyMove' },
  { keys: ['↵'], label: 'menu:magicSearchKeyOpen' },
  { keys: ['esc'], label: 'menu:magicSearchKeyClose' },
] as const;

export const MagicSearchFooter = () => {
  const { t } = useTranslation();

  return (
    <div
      className='hidden shrink-0 items-center gap-5 border-t border-extra-soft px-4 py-2.5 text-body-xs text-tertiary sm:flex'
      aria-hidden
      data-testid='magic-search--footer'>
      {KEY_HINTS.map(({ keys, label }) => (
        <span key={label} className='flex items-center gap-1.5'>
          {keys.map((key) => (
            <kbd key={key} className={MAGIC_SEARCH_KEY_CLASS}>
              {key}
            </kbd>
          ))}
          {t(label)}
        </span>
      ))}
    </div>
  );
};
